<template>
  <div class="reset-password">
    <h2>Reset password</h2>
    <p class="reset-password__description bhGray1--text">
      Enter email account associated to this account
    </p>
    <v-form v-model="valid">
      <v-text-field
        v-model="email"
        :rules="emailRules"
        class="bh-input"
        prepend-inner-icon="bhi-email"
        label="Email"
        placeholder=" "
        regular
        required
      ></v-text-field>
      <v-text-field
        v-model="confirmEmail"
        :rules="emailRules"
        class="bh-input"
        prepend-inner-icon="bhi-email"
        label="Re-enter Email"
        placeholder=" "
        regular
        required
      ></v-text-field>
      <div class="v-form__append d-flex justify-space-between align-center">
        <v-btn
          elevation="0"
          class="reset-password__back-button"
        >
          <span class="back-icon">&nbsp;</span>
        </v-btn>
        <v-btn type="submit" color="accent" elevation="0" rounded>
          Reset Validation
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "ResetPassword",
  components: {},
  data: () => ({
    valid: false,
    email: "",
    confirmEmail: "",
    emailRules: [
      v => !!v || "Email is required",
      v =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          String(v).toLowerCase()
        ) || "Email must be valid"
    ]
  })
};
</script>

<style lang="scss">
.reset-password {
  width: 100%;
  max-width: 328px;

  &__description {
    max-width: 210px;
  }

  &__back-button.v-btn {
    width: 32px;
    background: $bh-blue--4;
    min-width: 0 !important;
    height: 32px !important;
    padding: 0 !important;
    text-align: center;
  }
}
</style>
